// Keeps the fields that are sent on the salesforce request but not included on any form
export default {
  zero: 'zero'
}
